import { phoneNumberValidation } from "utils";
import * as yup from "yup";
import { LongPaymentFormFields } from "./LongPaymentForm";
import { AccountInformationFormEnum } from "./steps/AccountInformationStep";
import { ContactDetailsFormEnum } from "./steps/ContactDetailsStep";
import { PaymentMethodFormEnum } from "./steps/PaymentMethodStep";

export const longPaymentFormSchema = () =>
  yup.object().shape({
    [AccountInformationFormEnum.FirstName]: yup
      .string()
      .required("First Name is required field"),
    [AccountInformationFormEnum.LastName]: yup
      .string()
      .required("Last Name is required field"),
    [AccountInformationFormEnum.Email]: yup
      .string()
      .required("Email is required field")
      .email("Please use valid email adress"),
    [PaymentMethodFormEnum.PaymentMethod]: yup
      .string()
      .required("Payment method is required"),
    [ContactDetailsFormEnum.City]: yup
      .string()
      .required("City is required field"),
    [ContactDetailsFormEnum.Country]: yup
      .string()
      .required("Country is required field"),
    [ContactDetailsFormEnum.State]: yup
      .string()
      .when(ContactDetailsFormEnum.Country, {
        is: (value: string) => value === "United States",
        then: yup.string().required("State is required field"),
        otherwise: yup.string().notRequired(),
      }),
    [ContactDetailsFormEnum.Phone]: yup
      .string()
      .required("Phone number is required field")
      .test("phoneNumber", "Phone number is invalid", (val) =>
        phoneNumberValidation(val)
      ),
    [LongPaymentFormFields.TermsAccepted]: yup
      .boolean()
      .isTrue("T&C is required field")
      .required("T&C is required field"),
  });
